/** Display label for an OpenFGA role name: "billing_admin" → "Billing admin". */
export function humanRole(role: string): string {
  return role.charAt(0).toUpperCase() + role.slice(1).replace(/[-_]/g, " ");
}
